import axios from 'axios';
import BaseAPI from './base-api';

export default class HealthCheckAPI extends BaseAPI {
  static async healthCheck() {
    const { errorCode, result, } = await BaseAPI.promiseWrapper<string>(axios({
      url: `${window.feHost}/api/LoanApplications/Ping`,
      method: 'GET',
      headers: this.getRequestHeaders(),
    }));

    return errorCode === -1
      ? ({ errorCode: -1, })
      : ({ errorCode, message: (JSON.parse(result || '').error || { }).message, });
  }
}
